// extracted by mini-css-extract-plugin
export default {"wrap":"TabsMenu_wrap_VabIx","bar":"TabsMenu_bar_Gtd6c","item":"TabsMenu_item_ugoPp","icon-wrap":"TabsMenu_icon-wrap_S2UGf"};